import { useEffect } from 'react';

export function useScript({
  id,
  src,
  body,
  async,
  defer = false,
}: {
  /** script element id */
  id?: string;
  /** Provide only one of src or body */
  src?: string;
  /** Provide only one of src or body */
  body?: string;
  /** Defaults to true when src is provided, otherwise false */
  async?: boolean;
  defer?: boolean;
}) {
  useEffect(() => {
    const script = document.createElement('script');

    if (id) {
      script.id = id;
      script.dataset.testid = id;
    }
    if (src) script.src = src;
    if (!src && body) script.innerHTML = body;

    script.async = async ?? !!src;
    script.defer = defer;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [async, body, defer, id, src]);
}
